import Chart from "react-apexcharts";
import { formatPrice } from "utils/helpers/numbers";
import useIsMobileView from "hooks/useIsMobileView";
import { useMemo } from "react";
import { useTheme } from "@mui/material";

function PortfolioChart({ portfolioChart, color, lightThemModal }) {
  const theme = useTheme();
  const isMobileView = useIsMobileView();

  const chartData = useMemo(() => {
    const allDetails =
      portfolioChart?.map((detail) => ({
        percent: detail.usdtPercent,
        label: detail.name,
        value: detail.totalBalance,
      })) || [];

    const labels = allDetails?.map((detail) => detail.label);

    const series = allDetails?.map((detail) => detail.percent);

    const values = allDetails?.map((detail) => detail.value);

    return { values, labels, series, allDetails };
  }, [portfolioChart]);

  const chartOptions = {
    theme: {
      palette: "palette1",
      monochrome: {
        enabled: false,
        shadeTo: "dark",
        shadeIntensity: 0.55,
      },
    },
    stroke: {
      show: false,
    },
    tooltip: {
      enabled: true,
      custom: function ({ seriesIndex, w }) {
        return `<div>
                    <span style="padding:5px;">
                      ${w.globals.labels[seriesIndex]}
                    </span>
                  </div>`;
      },
    },
    series: [
      {
        name: chartData?.labels,
        data: chartData?.values,
      },
    ],
    dataLabels: {
      enabled: false,
    },
    labels: chartData?.labels,
    legend: {
      show: true,
      fontSize: "14px",
      fontWeight: 400,
      width: 250,
      labels: {
        colors: color || theme.palette.text.main,
        useSeriesColors: false,
      },
      formatter: function (val, opts) {
        return [
          val,
          ": ",
          formatPrice(chartData?.allDetails?.[opts.seriesIndex].value),
        ];
      },
      position: isMobileView ? "bottom" : "right",
    },
    chart: {
      height: 100,
      type: "donut",
      background: undefined,
      zoom: {
        selection: {
          border: color || theme.palette.text.main,
        },
      },
    },
    plotOptions: {
      pie: {
        labels: {
          enabled: true,
          formatter: function (val) {
            return val + "%";
          },
        },
        expandOnClick: true,
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "10px",
              fontWeight: 700,
              color: lightThemModal
                ? theme.palette.text.main
                : theme.palette.common.white,
              offsetY: -10,
              formatter: function (val) {
                return val;
              },
            },
            value: {
              show: true,
              fontSize: "14px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: lightThemModal
                ? theme.palette.text.main
                : theme.palette.common.white,
              offsetY: 2,
              formatter: function (val) {
                return [val + "%"];
              },
            },
          },
        },
      },
    },
  };

  return (
    <Chart
      // label={chartData?.labels}
      series={chartData?.series}
      options={chartOptions}
      type={"donut"}
      width={isMobileView ? "100%" : "440px"}
      height={isMobileView ? "400px" : ""}
    />
  );
}

export default PortfolioChart;
